/** @format */
import { CSSProperties } from 'react';

export function flipMovementDirection(movement: number) {
    return movement * -1;
}

export function getNextIndex(
    elementWidth: number,
    xMovement: number,
    activeIndex: number
) {
    const movement = flipMovementDirection(xMovement);
    const movementThreshold = 0.25;

    const percentageMovementOfAcrossElement = movement / elementWidth;
    const isMovementOverThreshold =
        Math.abs(percentageMovementOfAcrossElement) > movementThreshold;

    if (!isMovementOverThreshold) return activeIndex;

    // When dragging to move back, it gives a negative value so we need to set the offset to -1
    const indexOffset = percentageMovementOfAcrossElement > 0 ? 1 : -1;

    return activeIndex + indexOffset;
}

export function getRotationElementStyle(
    itemIndex: number,
    arcOfRotation: number,
    radiusOfRotationArc: number,
    itemCount: number
): CSSProperties {
    const step = arcOfRotation / itemCount;

    return {
        width: '100%',
        height: '100%',
        position: itemIndex === 0 ? 'static' : 'absolute',
        transform: `translateY(${radiusOfRotationArc}%) rotate(${
            step * itemIndex
        }deg) translateY(-${radiusOfRotationArc}%)`,
    };
}
